import type { MembershipRole } from './api';

/**
 * Client-side mirror of the server's role matrix (docs/TEAMS_AND_PROJECTS.md,
 * enforced by requireRole in the API). Cosmetic only — hiding a button is UX,
 * the server is authoritative.
 */
export type RoleAction =
  | 'move_money' // transfers, payouts, wallet/fiat creation, deposit addresses
  | 'set_rates'
  | 'create_orders'
  | 'manage_keys' // API keys AND webhook endpoints
  | 'manage_team' // members, roles, invites
  | 'manage_projects';

const MATRIX: Record<RoleAction, MembershipRole[]> = {
  move_money: ['owner', 'admin', 'treasurer'],
  set_rates: ['owner', 'admin', 'treasurer'],
  create_orders: ['owner', 'admin', 'operator'],
  manage_keys: ['owner', 'admin', 'developer'],
  manage_team: ['owner', 'admin'],
  manage_projects: ['owner', 'admin'],
};

export function can(role: MembershipRole | undefined, action: RoleAction): boolean {
  if (!role) return false;
  return MATRIX[action].includes(role);
}

export const ROLE_LABELS: Record<MembershipRole, string> = {
  owner: 'Owner',
  admin: 'Admin',
  treasurer: 'Treasurer',
  developer: 'Developer',
  operator: 'Operator',
};

export const ROLE_DESCRIPTIONS: Record<MembershipRole, string> = {
  owner: 'Everything, including team, projects and other owners',
  admin: 'Everything except other owners',
  treasurer: 'Moves money: payouts, transfers, rates, funding',
  developer: 'API keys, webhooks and read-only balances',
  operator: 'Orders and read-only balances',
};

export const ASSIGNABLE_ROLES: MembershipRole[] = [
  'owner',
  'admin',
  'treasurer',
  'developer',
  'operator',
];
